import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as e } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const a = e((r, t) => /* @__PURE__ */ o.jsx(
  i,
  {
    ref: t,
    ...r,
    image: (s) => /* @__PURE__ */ o.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...s,
        children: [
          /* @__PURE__ */ o.jsx(
            "circle",
            {
              cx: 8,
              cy: 8,
              r: 7,
              stroke: "currentColor",
              strokeWidth: 2,
              opacity: 0.4
            }
          ),
          /* @__PURE__ */ o.jsx("path", { stroke: "currentColor", strokeWidth: 2, d: "M1 8a7 7 0 1 0 7-7" })
        ]
      }
    )
  }
));
a.displayName = "LoadingIcon";
export {
  a as LoadingIcon,
  a as default
};
//# sourceMappingURL=index.js.map
